import {Directive, ElementRef, Input, OnChanges, SimpleChanges} from '@angular/core';

@Directive({
    selector: '[colorContrast]',
    standalone: false
})
export class ColorContrastDirective implements OnChanges {
  DARK = '#000000';
  LIGHT = '#FFFFFF';
  @Input() colorContrast;

  constructor(private el: ElementRef) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.colorContrast) {
      this.colorContrast = changes.colorContrast.currentValue;
      this.setColor(this.el, this.colorContrast);
    }
  }

  getContrastYIQ(hexcolor) {
    const r = parseInt(hexcolor.substr(0, 2), 16);
    const g = parseInt(hexcolor.substr(2, 2), 16);
    const b = parseInt(hexcolor.substr(4, 2), 16);
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 150) ? this.DARK : this.LIGHT;
  };

  stripNumberSign(color) {
    if (color[0] === '#') {
      color = color.substring(1, color.length);
    }
    return color;
  };

  setColor(element, color) {
    if (color) {
      color = this.stripNumberSign(color);
      element.nativeElement.style.color = this.getContrastYIQ(color);
    }
  }
};
